import { listSheets, loadRawSheets, loadSheets } from './sheetclient.js';
import { loadCardImages } from './card_images.js';
import { tick } from 'svelte/internal';
import { get } from 'svelte/store';
import { clone, ui, res, prefs, state } from './stores.js';
import { loadPrefs } from './save.js';
import { get as IDBget } from 'idb-keyval';
import { parseCards } from './pegparse.js';
import { getUniqueID } from './game.js';
import {default as parser} from './grammar.pegjs';
import { campaignRewards, setCampaignRewards } from './campaign.js';
import { loadKhanDash } from './khan.js';
import { waitMillis } from './ui.js';
import { janewayPassives } from './janeway.js';
import { possArray } from './card_actions.js';
import { setupSounds } from './sounds.js';

function sheetID(){
  if(get(res).stagingSheet){
    return get(res).stagingID;
  }else{
    return '1PHBOJSjC4XTxhLwrKhepGMdGiZTVcytKUgg0zIWin6A';//'1BJSXGP2wlDqfVjlrp_pJFbmRrv-zZSKkybq3rwxcp6c';//'1YnNEeL27AN40qNea5Gs8MpHuQfSPkLB0FKae03OE9JM';
  }
}

export async function asyncPC(cards){
  let worker = new Worker("./parse.js", {type: "module"});
  return new Promise((resolve, reject) => {
    worker.onmessage = (e) => {
      resolve(e.data);
    }
    worker.postMessage(cards);
  })
}

function analyseCards(cards, text){
  let ac = analyseComponents(cards);
  let bits = ac.allKeys;
  let typed = ac.typedKeys;
  console.log(text+': '+bits.sort().join(', '))
  let typedString = '';
  for(let t of Object.keys(typed)){
    let s = `${t}: ${typed[t].sort().join(', ')}`;
    typedString += s + '\n';
  }
  //console.log(typedString);
  //console.log('Keys and objects:');
  for(let k of Object.keys(ac.keysObjects)){
    //console.log(`${k}: ${ac.keysObjects[k].sort().join(', ')}`);
  }
}

function logLoad(string, progress = false){
  ui.update(ui => {
    ui.loadingDetail = string;
    ui.loadingProgress = progress;
    return ui;
  })
}

function loadProgress(x){
  ui.update(ui => {
    ui.loadingProgress = x;
    return ui;
  })
}

export function getAvailableCaptains(){
  return Array.from(new Set(get(res).cards.filter(c => c.suits.includes('captain')  && !c.id.includes('B/') && !['@Mirror', 'Common'].includes(c.deck)).map(c => c.deck), Object.keys(get(res).dashboards)));
}

export async function loadAll(forceReload = false){
  //let r = {};
  
  
  res.update(r => {
    r.parsedCardText = {}; // reparsed each load – takes ~2s now the parser is memoised
    r.cachedTrawls = {}; // derived from parsedCardText, so must go with it
    return r;
  })

  let addLoader = async (key, prom, log) => {
    //logLoad('getting '+log);
    let val = await prom;
    res.update(r => {
      r[key] = val;
      return r;
    })
  }

  setupSounds(); // no tracking for this at present, it's not very important

  let promises = [
    loadPrefs(),
    addLoader('cards', loadCards(), 'card list'),
    addLoader('sets', loadSets(), 'list of expansions'),
    addLoader('stardateCards', loadStardates(), 'stardate card data'),
    //addLoader('customDashboards', loadCustomPassives(), 'custom dashboard passives'),
    addLoader('dashboards', loadDashboards(), 'dashboards'),
    addLoader('commonMissions', loadCommonMissions(), 'common missions deck'),
    addLoader('campaignRewards', loadCampaignRewards(), 'campaign rewards'),
    addLoader('botSpecialRules', loadBotSpecialRules(), 'bot special rules'),
    //addLoader('botCharts', loadBotCharts(), 'bot charts'),
    addLoader('species', loadSpecies(), 'species list')
  ];

  logLoad('getting data from master sheet');
  await Promise.all(promises);
  
  logLoad('getting bot charts');
  let bc = await loadBotCharts(); // afterwards because it pulls on captainsAvailable
  res.update(r => {
    r.botCharts = bc;
    return r;
  })

  setCampaignRewards(get(res).campaignRewards);

  
  let traits = await loadTraits(get(res).cards);
  let allStardates = get(res).stardateCards;
  res.update(r => {
    r.traits = traits;
    r.allStardates = allStardates;
    return r;
  })
  
  console.log(new Set(get(res).cards.filter(c => c.suits.includes('captain')).map(c => c.deck), Object.keys(get(res).dashboards)));
  let captainsAvailable = getAvailableCaptains();
  let captainsToRemove = captainsAvailable.filter(c => !get(res).dashboards.hasOwnProperty(c) || !get(res).cards.some(cd => cd.suits.includes('captain') && cd.deck == c));
  res.update(r => {
    // dedupe by id: basic + advanced dashboards share the same passive (same id), so it'd be added twice
    let dashCards = Object.values(r.dashboards).flatMap(d => [...d.missions, ...possArray(d.passives)]).filter(c => c);
    r.cards = [...r.cards, ...[...new Map(dashCards.map(c => [c.id, c])).values()]];
    if(r.commonMissions) r.cards = [...r.cards, ...r.commonMissions];
    return r;
  })
  
  
  let cardsToRemove = get(res).cards.filter(c => captainsToRemove.includes(c.deck));
  console.log('Cards removed because deck not ready yet:', cardsToRemove)
  // TODO below just to avoid later boxes
  //cardsToRemove = [...cardsToRemove, ...r.cards.filter(c => c && c.id && !c.id.startsWith('1'))];
  // TODO end
  res.update(r => {
    r.cards = r.cards.filter(c => !cardsToRemove.includes(c));
    r.cards = [...r.cards, ...r.botCharts.cards, ...Object.keys(r.dashboards).flatMap(k => r.dashboards[k].missions)]; // So parse errors for them show up too!
    r.suits = getSuits(r.cards);
    r.tokens = ['latinum', 'dilithium', 'glory', 'power', 'whim']
    r.tracks = ['research', 'military', 'influence', 'treachery']
    r.icons = [...r.traits, ...r.suits, ...r.tokens, ...r.tracks, 'actions', 'activations', 'mil-guard', 'res-guard', 'inf-guard', 'spec-res', 'spec-mil', 'spec-inf', 'res-skill', 'res-focus', 'inf-skill', 'inf-focus', 'mil-skill', 'mil-focus', 'wild-skill', 'inf-restriction', 'mil-restriction','res-restriction'];
    r.allCards = [...r.cards, ...cardsToRemove];
    return r;
  });
  
  /*logLoad('getting bot charts');
  r.botCharts = await loadBotCharts(captainsAvailable);*/
  
  
  //console.log(r.dashboards)
  
  /*r.species = await loadSpecies();
  console.log(r.species)*/

  /*res.update(re => {
    re = {...re, ...r};
    
    return re;
  })*/

  logLoad('parsing card text');

  await parseCards([...get(res).allCards, ...stardatesToParse()]);
  //await asyncPC(r.cards);

  /*let parsed = get(res).parsedCardText;
  console.log(parsed);
  console.log(Object.keys(parsed).filter(k => parsed[k].reaction).map(k => `${k}: ${parsed[k].reaction.text}`))
  analyseCards(r.cards, 'All cards');
  analyseCards(r.botCharts.cards, 'Bot cards');*/
  //navigator.clipboard.writeText(typedString);
  
  /*console.log('incomplete:', Array.from(new Set(r.cards.filter(c => findIncompleteText(c)).flatMap(c => findIncompleteText(c).incomplete).map(c => c.text).sort())));
  console.log('complete:', Array.from(new Set(r.cards.filter(c => findIncompleteText(c)).flatMap(c => findIncompleteText(c).complete).map(c => c.text).sort())));
  let cardsPartiallyDone = Object.keys(parsed).length;
  let cardsOnlyPartDone = Object.keys(parsed).filter(k => Object.keys(parsed[k]).some(q => parsed[k][q].incomplete)).length;
  let cardsTotallyDone = cardsPartiallyDone - cardsOnlyPartDone;
  let percentGettingThere = cardsPartiallyDone / r.cards.length;
  let percentDone = cardsTotallyDone / r.cards.length;
  console.log(`${Math.round(percentDone * 100)}% of cards fully parsed (${cardsTotallyDone})`);
  console.log(`${Math.round(percentGettingThere * 100)}% of cards at least partially parsed (${cardsPartiallyDone}, ${cardsOnlyPartDone})`);
  //console.log(`${r.cards.length - cardsDone} totally incomplete cards:`, r.cards.filter(c => !get(res).parsedCardText[c.id]));
  */

  logLoad('getting images')
  await loadCardImages(get(res).cards, loadProgress, forceReload);
}

function findChartVersion(str){
  let match = str.match(/v(\d+)/);
  if(match) return parseInt(match[1]);
  return 0;
}

function isBlank(str){
  if(!str) return true;
  if(str.match(/^[ \-]*$/)) return true;
  return false;
}

export async function loadBQChart(chartName){
  let botChartID = '1AcwKnCwbdwt4_ID3cb_ljlkPiqWpHxnvOLOVfESmswg';
  let basicChart = await loadSheets({
    id: botChartID,
    sheetName: 'Borg Queen',
    startCol: 'A',
    endCol: 'D'
  });
  let syncChart = await loadSheets({
    id: botChartID,
    sheetName: 'Borg Queen',
    startCol: 'F',
    endCol: 'H'
  });
  let chart = [];
  let fakeCards = [];
  if(!syncChart || !basicChart) alert('Error loading BQ bot chart')
  for(let row of [...syncChart, ...basicChart]){
    let entry = {};
    if(row['Sync level']){
      entry.origIcon = `[[sync]] ${row['Sync level']}`;
      entry.syncLevel = parseInt(row['Sync level']);
      entry.icon = 'sync'
    }else if(isBlank(row['Icon']) || !['[[', 'non-'].some(c => row['Icon'].startsWith(c))){
      continue; // Skip rows without icons
    }else{
      entry.origIcon = row['Icon'].toLowerCase();
      entry.icon = row['Icon'].replaceAll(/\[|\]/g,'').split('/').map(i => i.trim());
      entry.exclude = ['sync'];
      if(entry.origIcon == 'non-[[borg]]'){
        entry.icon = '!any';
        entry.exclude.push('borg');
      }
      if(entry.icon.length == 1) entry.icon = entry.icon[0];
    }
    let conversions = {
      '-': 'basic',
      'Collective <20': 'collective<20',
      'Collective >=20': 'collective>=20'
    }
    for(let e of Object.keys(conversions)){
      if(isBlank(row[e])) continue;
      let c = {
        name:`${chartName} bot chart ${entry.origIcon} ${e}`,
        allText: 'Play: '+row[e].trim(),
        text: row[e],
        icon: entry.icon,
        syncLevel: entry.syncLevel || false,
        exclude: entry.exclude,
        id: `${chartName}_bot_${entry.origIcon}}_${e}`,
        //uniqueID: getUniqueID(),//`${captain}_bot_${row['Icon']}_${e}`,
        suits: [],
        traits: [],
        values: [],
        ships: [],
        botCard: true
      }
      if(!c.allText.endsWith('.')) c.allText = c.allText + '.'; // So that it parses correctly!
      entry[conversions[e]] = c;
      fakeCards.push(c);
    }
    chart.push(entry);
  }
  return {
    fakeCards,
    chart
  };
}

export async function loadSingleBotChart(captain, chartName){
  if(captain == 'Borg Queen') return await loadBQChart(chartName);
  let botChartID = '1AcwKnCwbdwt4_ID3cb_ljlkPiqWpHxnvOLOVfESmswg';
  let loaded = await loadSheets({
    id: botChartID,
    sheetName: chartName,
    startCol: 'A',
    endCol: 'DD'
  })
  let chart = [];
  let fakeCards = [];
  if(!loaded) alert('Error loading sheets')
  for(let row of loaded){
    if(isBlank(row['Icon']) || !['non-', '[['].some(c => row['Icon'].startsWith(c))) continue; // Skip rows without icons
    let entry = {};
    entry.origIcon = row['Icon'].toLowerCase();
    if(entry.origIcon.startsWith('non-')){
      entry.exclude = entry.origIcon.split('-').slice(1).join('-');
      entry.icon = '!any'; // NB a bot chart with non-[[dsd]] [[sdsd]] will currently fail, so be aware
    }
    entry.icon = row['Icon'].replaceAll(/\[|\]/g,'').split('/').map(i => i.trim());
    
    if(entry.icon.length == 1) entry.icon = entry.icon[0];
    let conversions = {
      '-': 'basic',
      'Basic': 'basic',
      'non-DO effect': 'noDO',
      'DO effect': 'DO',
    }
    for(let e of Object.keys(conversions)){
      if(isBlank(row[e])) continue;
      let c = {
        name:`${chartName} bot chart ${row['Icon']} ${e}`,
        allText: 'Play: '+row[e].trim(),
        text: row[e],
        icon: entry.icon,
        id: `${chartName}_bot_${row['Icon']}_${e}`,
        //uniqueID: getUniqueID(),//`${captain}_bot_${row['Icon']}_${e}`,
        suits: [],
        traits: [],
        values: [],
        ships: [],
        botCard: true
      }
      if(!c.allText.endsWith('.')) c.allText = c.allText + '.'; // So that it parses correctly!
      entry[conversions[e]] = c;
      fakeCards.push(c);
    }
    chart.push(entry);
  }
  return {
    fakeCards,
    chart
  };
}

export async function loadBotCharts(forceReparse){
  let botChartID = '1AcwKnCwbdwt4_ID3cb_ljlkPiqWpHxnvOLOVfESmswg';
  if(get(res).useSandbox) botChartID = get(res).botSandboxID;
  let chartsList = await listSheets(botChartID);
  let botCharts = {};
  let fakeCards = [];
  /*let botsToRelease = ['Picard', 'Shran', 'Koloth', 'Sela', 'Sisko', 'Burnham', 'Kirk', 'Rebner', 'Georgiou', 'Soval', 'Khan', 'Archer', 'Pike', 'Freeman', 'Riker',
    'Janeway', 'Dal & Gwyn', 'Boimler', 'Shaw', 'Borg Queen', 'Worf', 'Dukat'
  ]*/

  // Only captains that actually have a sheet — getAvailableCaptains() returns every captain deck, most have no bot
  let captainsToCheck = getAvailableCaptains().filter(c => chartsList.some(s => s.toLowerCase().startsWith(c.toLowerCase())));
  let done = 0;

  let loadCaptain = async (captain) => {
    //if(!botsToRelease.includes(captain)) continue; // Just those two for now
    let charts = chartsList.filter(c => c.toLowerCase().startsWith(captain.toLowerCase()));
    if(charts.length == 0) return;
    if(charts.some(c => c.includes('-'))){
      // Different stages
      botCharts[captain] = {};
      for(let c of charts){
        let stage = captain.toLowerCase();
        if(c.split('-').length > 1) stage = c.split('-')[1].toLowerCase();
        let basic = c.split('-')[0];
        botCharts[captain].chartName = basic;
        let chart = await loadSingleBotChart(captain, c);
        botCharts[captain][stage] = chart.chart;
        if(basic == 'Shaw' && stage == 'seven'){
          // Fill in gaps for chart. fakecards not needed I think because duplicates
          for(let row of botCharts.Shaw.shaw){
            if(row.noDO){ // It's a suit row
              // Copy it across
              botCharts.Shaw.seven = botCharts.Shaw.seven.filter(r => r.icon != row.icon);
              botCharts.Shaw.seven.push(row);
            }
          }
        }
        fakeCards.push(...chart.fakeCards);
      }
      console.log(botCharts);
    }else{
      if(charts.length > 1) charts = charts.sort((a,b) => findChartVersion(b) - findChartVersion(a));
      let chartName = charts[0]; // Most recent version
      // Now extract the contents
  
      let chart = await loadSingleBotChart(captain, chartName);
      fakeCards.push(...chart.fakeCards)
      
      botCharts[captain] = {
        chartName,
        chart: chart.chart
      }
    }
    done++;
    logLoad(`getting bot charts (${done}/${captainsToCheck.length})`);
  }

  // ponytail: fixed chunk of 6 to stay under the Sheets 60 reads/min/user quota; use a proper limiter if captain count grows a lot
  for(let i = 0; i < captainsToCheck.length; i += 6){
    await Promise.all(captainsToCheck.slice(i, i + 6).map(loadCaptain));
  }

  // Next we need to parse them!
  botCharts.cards = fakeCards;
  if(forceReparse) await parseCards(botCharts.cards, true);
  console.log(botCharts);

  return botCharts;
}

function getReverse(ref){
  if(!ref) return false;
  let i = ref.indexOf('/')
  if(!i) return false;
  let side = ref[i - 1];
  let otherSide;
  if(side == 'A'){
    otherSide = 'B';
  }else if(side == 'B'){
    otherSide = 'A';
  }else{
    return false;
  }
  let arr = ref.split('');
  return [...arr.slice(0, i - 1), otherSide, '/', ...arr.slice(i+1)].join('');
}

function isBack(ref){
  if(!ref) return false;
  let i = ref.indexOf('/')
  if(!i) return false;
  let side = ref[i - 1];
  if(side == 'B'){
    console.log('B side found', ref)
    return true;
  }
  return false;
}

export async function loadCommonMissions(){
  let loaded = await loadSheets({
    id: sheetID(),
    sheetName: '!Missions',
    startCol: 'A',
    endCol: 'XX'
  });
  if(!loaded) return [];
  let list = [];
  for(let l of loaded){
    let c = {
        name: l['Card Name'],
        allText: `${l['Hand Effect'] || ''} ${l['Table Effect'] || ''} ${l['Goal'] || ''} ${l['Special/Resupply'] || ''}${l['Development cost'] ? ` Development cost: ${l['Development cost']}` : ''}`,
        id: l['RefNumber'],
        //uniqueID: getUniqueID(),//`borg_passives`,
        suits: [(l['Primary Suit'] || 'mission').toLowerCase()],
        traits: `${l['Traits'] || ''}`.split(',').map(t => t.trim().toLowerCase()),
        ships: [],
        values: [],
        deck: 'Missions',
        changedOn: l['CHANGED ON'] || '20/12'
    }
    let vp = parseInt(l['VP']);
    if(['influence', 'research', 'military', 'wild'].includes(l['VP'])){
      c.focus_vp = true;
      c.stripe = l['VP'];
    }else if(!isNaN(vp)){
      c.vp = vp;
    }
    if(l['Power']){
      let vals = l['Power'].split(',').map(t => t.trim().toLowerCase());
      for(let v of vals){
        if(v == 'ship-token'){
          c.ships = [c.name.toLowerCase().replaceAll(' ', '_')];
        }else{
          c.values = [...c.values, v];
        }
      }
    }
    if(l['Locations']){
      c.area = l['Locations'];
    }
    list = [...list, c];
  }
  return list;
}

let customDashes = {};

export async function loadCustomPassives(){
  let captains = ['Borg Queen', 'Q', 'Gorn'];
  let values = await loadRawSheets({
    id: sheetID(),
    sheetName: 'Custom Dashboards',
    startCol: 'A',
    endCol: 'J'
  })

  let passives = {};
  let tracks = {};
  let customDashboards = {};

  console.log('Custom dashboards', values);
  for(let i = 0; i < values.length; i++){
    let row = values[i];
    if(row[0] && captains.some(c => row[0].startsWith(c))){
      // We've found a passives section, so parse it
      i++;
      let cap = captains.find(c => row[0].startsWith(c));
      passives[cap] = [];
      while(i < values.length && values[i] && values[i][0] &&  isNaN(parseInt(values[i][0]))){
        // It's passives, not numbers
        passives[cap].push(values[i][0]);
        i++;
      }
      if(i < values.length && values[i] && values[i + 1] && values[i][0] && !isNaN(parseInt(values[i][0]))){
        // It's track numbers
        tracks[cap] = {};
        for(let j = 0; j < values[i].length; j++){
          let amount = values[i][j];
          if(amount){
            amount = parseInt(amount);
            let result = values[i + 1][j];
            if(result){
              if(result.startsWith('x')) result = result.slice(1);
              tracks[cap][amount] = parseInt(result) || result.replaceAll(/\[|\]/g, '');
            }
          }
        }
        i++;
      }
    }
  }
  for(let c of captains){
    customDashboards[c] = {};
    if(c == 'Q'){
      // Add the special discard & draw step
      passives[c].push(`~Clean-up: For each card in your hand, gain 1 [[whim]]. Discard any number of cards from your hand. For each card in your Staging Area, either: spend 1 [[whim]] to snap it OR log it to gain an [[action]] OR put it in your Discard pile. Then, you may spend 4 [[whim]] and destroy a non-[[incident]] card from your Log to shuffle your Discard pile into your Draw deck. Special: Resolve this card's clean-up operation at the start of the *Discard & Draw* step.`);
    }
    if(passives[c]) customDashboards[c].passives = makeDashboardPassives(c, passives[c]);
    if(tracks[c]) customDashboards[c].tracks = tracks[c];
  }
  customDashes = customDashboards;
  res.update(r => {
    r.customDashboards = customDashboards;
    return r;
  }) 
}

function makeDashboardPassives(captain, lines){
  return lines.map((l, i) => {
    let hidden = false;
    if(l.startsWith('~')){
      l = l.slice(1);
      hidden = true;
    }
    return {
      name:`${captain} dashboard passives #${i + 1}`,
      allText: l,
      text: l,
      id: `${captain}_passives_${i+1}`,
      //uniqueID: getUniqueID(),//`borg_passives`,
      suits: [],
      traits: [],
      values: [],
      ships: [],
      dashboardPassive: true,
      hidden,
      deck: captain
    }
  })
}


export async function loadDashboards(){
  await loadCustomPassives();
  let loaded = await loadSheets({
    id: sheetID(),
    sheetName: 'Dashboards',
    startCol: 'A',
    endCol: 'XX'
  });
  if(!loaded) return [];
  let dashes = {};
  let toParse = [];
  for(let d of loaded){
    let e = {};
    e.deck = d['Deck'];
    
    e.id = d['Ref'] || e.deck; // so blank ones get something!
    e.changedOn = d['latest change'] || '20/12';
    if(e.deck == 'Khan'){
      e = loadKhanDash(e); // Handcoded
      dashes[e.deck] = e;
      dashes[e.deck+'_basic'] = e; // Both the same presumably
      toParse.push(...e.missions);
      continue;
    }
    e.missions = [];
    e.passives = [];
    e.research = {};
    e.military = {};
    e.influence = {};
    e.trackScoring = {
      research: 0,
      military: 0,
      influence: 0
    }
    e.trackMultiplier = {
      research: 0,
      military: 0,
      influence: 0
    }
    if(e.deck == 'Borg Queen'){
      e.trackMultiplier.collective = 0;
      //e.passives = borgPassives();
    }

    if(customDashes[e.deck] && customDashes[e.deck].passives){
      e.passives = customDashes[e.deck].passives; // Borg, Q, etc.
    }

    
    
    let basic = clone(e);

    if(e.deck == 'Janeway'){ // after clone as just for advanced
      e.special = {
        type: 'special',
        text: 'These [[mission]] are treated as [[journey]].' // Jan 2026
      }
    }

    /*if(e.deck == 'Janeway'){ // after cloning so that basic dash doesn't have this passive
      e.passives =  [
        {
          name:`Janeway dashboard passives`,
          allText: janewayPassives(),
          text: janewayPassives(),
          id: `janeway_passives`,
          //uniqueID: getUniqueID(),//`janeway_passives`,
          suits: [],
          traits: [],
          values: [],
          ships: [],
          dashboardPassive: true,
          deck: 'Janeway'
        }
      ];
    }*/

    basic.research[0] = 1;
    basic.influence[0] = 1;
    basic.military[0] = 1;
    for(let i = 1; i < 16; i++){
      if(d['Mission'+i]){ // only first mission on basic
        let newMission = {
          name: d['Mission'+i],
          goal: d['goal'+i],
          reward: d['Reward'+i],
          allText: d['goal'+i]+' '+d['Reward'+i],
          id: `${e.id}_missions_${i}`,
          //uniqueID: getUniqueID(),//`${e.id}_missions_${i}`,
          suits: ['mission'],
          traits: [],
          values: [],
          ships: [],
          dashMission: true,
          deck: d['Deck']
        }
        if(!isNaN(parseInt(d['Vp'+i]))) newMission.vp = parseInt(d['Vp'+i]);
        e.missions.push(newMission);
        if(i == 1) basic.missions.push({...newMission, id: `${e.id}-basic_missions_${i}`, /*uniqueID: getUniqueID(),`${e.id}-basic_missions_${i}`,*/ vp: 0}); // Apparently basic missions still shouldn't score
        /*state.update(s => {
            s.cardsByID[newMission.uniqueID] = newMission; 
            return s;
        })*/
      }
      
      //await parseCards(e.missions);
      //await parseCards(basic.missions);
      /*res.update(r => {
        r.cards = [...r.cards, ...e.missions];
        return r;
      })*/
      // TODO add Collective for Borg
      if(d['Res'+i]) e.research[i] = parseInt(d['Res'+i].replace('x', ''));
      if(d['Inf'+i]) e.influence[i] = parseInt(d['Inf'+i].replace('x', ''));
      if(d['Mil'+i]) e.military[i] = parseInt(d['Mil'+i].replace('x', ''));
      if(d['BasicRes'+i]) basic.research[i] = parseInt(d['BasicRes'+i].replace('x', ''));
      if(d['BasicInf'+i]) basic.influence[i] = parseInt(d['BasicInf'+i].replace('x', ''));
      if(d['BasicMil'+i]) basic.military[i] = parseInt(d['BasicMil'+i].replace('x', ''));
    }
    toParse.push(...e.missions, ...basic.missions);
    if(d['_Filename']){
      e.image = d['_Filename'].toLowerCase()+'-advanced.png';
      //if(!get(res).stagingSheet) e.image = d['_Filename'].toLowerCase()+'.png';
      basic.image = d['_Filename'].toLowerCase()+'-basic.png';
    }
    //console.log(e.image);
    dashes[e.deck] = e;
    dashes[e.deck+'_basic'] = basic;
  }
  //await parseCards(toParse);
  console.log('Dashboards:', dashes)
  return dashes;
}

export async function loadCampaignRewards(){
  let botChartID = '1AcwKnCwbdwt4_ID3cb_ljlkPiqWpHxnvOLOVfESmswg';
  let loaded = await loadSheets({
    id: botChartID,
    sheetName: '_BotData',
    startCol: 'A',
    endCol: 'CC'
  });

  console.log('camp',loaded);

  if(!loaded) return {};
  let rewards = {};
  for(let r of loaded){
    let deck = r['Deck Name'].trim();
    if(deck.includes('-')) deck = deck.split('-')[0]; // For Khan
    let obj = {};
    try{
      obj.win = parser.parse(r['WinUpgradeA']);
      obj.win_alt = [
        parser.parse(r['WinUpgradeB1']),
        parser.parse(r['WinUpgradeB2'])
      ];
      obj.lose = parser.parse(r['LossUpgradeA']);
      obj.lose_alt = [
        parser.parse(r['LossUpgradeB1']),
        parser.parse(r['LossUpgradeB2'])
      ];
      rewards[deck] = obj;
    }catch(e){
      console.log(`No campaign rewards available for ${deck}:`, e);
      rewards[deck] = false;
    }
  }
  console.log('campaign rewards', rewards);
  return rewards;
}

// Display only: the rules themselves are handcoded in the bot logic
// Keyed by lowercased '_BotData' deck name, e.g. 'burnham', 'khan-exile', 'shaw-seven'
export async function loadBotSpecialRules(){
  let loaded = await loadSheets({
    id: '1AcwKnCwbdwt4_ID3cb_ljlkPiqWpHxnvOLOVfESmswg',
    sheetName: '_BotData',
    startCol: 'A',
    endCol: 'CC'
  });
  let rules = {};
  for(let r of loaded || []){
    if(r['Deck Name'] && !isBlank(r['SpecialRule'])) rules[r['Deck Name'].trim().toLowerCase()] = r['SpecialRule'].trim();
  }
  return rules;
}

export async function loadSpecies(){
  let loaded = await loadSheets({
    id: sheetID(),
    sheetName: '_All Traits',
    startCol: 'A',
    endCol: 'K'
  });

  if(!loaded) return [];
  return Array.from(new Set([...loaded.map(l => l['Species'].toLowerCase().trim()).filter(t => t)]));

}

export async function loadTraits(cards = []){
  let collatedList = [];
  for(let c of cards){
    if(c.traits.includes(',')) console.log(c.traits)
    collatedList.push(...c.traits);
  }
  collatedList.push('different-species', 'different species', 'any species', 'same-species', 'same species');
  return Array.from(new Set(collatedList));
  // Old version below
    let loaded = await loadSheets({
        id: sheetID(),
        sheetName: '_All Traits',
        startCol: 'D',
        endCol: 'D'
      });
      if(!loaded) return [];
      let icons = [];
      for(let i of loaded){
        icons.push(i['Dynamic tag list']); // TODO keep in sync
      }

      let p = await IDBget('prefs');
      if(p){
        prefs.update(pr => {
          pr = {...pr, ...p};
          return pr;
        })
      }

      return icons.map(i => i.toLowerCase());
}

export function getSuits(cards){
    return Array.from(new Set(cards.flatMap(c => c.suits)));
}

function convertNewCard(c){
  let ret = {};
  let staging = c['(STAGING)'];
  if(staging && staging.trim().length > 0){
    //console.log('staging', staging)
    ret.staging = staging.trim();
  }
  ret.suits = [];
  ret.name = c['Name'];
  if(ret.name.startsWith('~')){
    ret.name = ret.name.slice(1);
    ret.red = true;
  }
  if(ret.name.startsWith('$')){
    ret.name = ret.name.slice(1);
    ret.blue = true;
  }
  ret.deck = c['!!Filter'] || undefined;
  if(c['!!DateChange']) ret.changedOn = c['!!DateChange'];
  if(ret.deck == '!_CommonCards'){
    if(c['Ref'].includes('LOC')){
      ret.deck = 'Locations';
    }else{
      ret.deck = 'Common'
    }
  }
  if(ret.deck && ret.deck.startsWith('!')) ret.deck = ret.deck.slice(1);
  let match;
  if(match = c['@Suit'].match(/suit-([^.]+)\.psd/)){
    ret.suits = [ match[1].trim() ];
  }

  if(ret.suits.includes('captain') && !['@Mirror', 'Common'].includes(ret.deck)){
    res.update(r => {
      let cap = ret.deck;
      if(!r.captains.includes(cap)) r.captains = [...r.captains, cap];
      return r;
    })
  }

  /*ret.pips = 0;
  if(c['@Pip1']){
    if(c['@Pip1'].includes('deployed')){
      ret.area = 'Deployed';
    }else if(c['@Pip1'].includes('supply')){
      ret.area = 'Supply';
    }else if(c['@Pip1'].includes('discard')){
      ret.area = 'Discard';
    }else{
      ret.pips++;
    }
  }*/
  c['WIZ_Zone'] = c['WIZ_Zone'].trim();
  if(c['WIZ_Zone'] == 'AVAILABLE'){
    ret.area = 'Starter';
  }else if(c['WIZ_Zone'] == 'DEPLOYED'){
    ret.area = 'Deployed';
  }else if(c['WIZ_Zone'] == 'CONTROLLED LOCATION'){
    ret.area = 'Controlled';
  }else if(c['WIZ_Zone'] == 'DEVELOPMENT'){
    ret.area = 'Development';
  }else if(c['WIZ_Zone'] == 'RESERVE'){
    ret.area = 'Reserve';
  }else if(c['WIZ_Zone'] == 'DISCARD'){
    ret.area = 'Discard';
  }else if(c['WIZ_Zone'] == 'INCIDENT DECK'){
    ret.area = 'Supply';
  }else if(c['WIZ_Zone'] == 'BEAMED'){
    ret.area = 'Beamed';
  }else if(c['WIZ_Zone'] == 'DUTY OFFICER'){
    ret.area = 'Duty';
  }else if(c['WIZ_Zone'] == 'STARTING LOCATION'){
    ret.area = 'Starting Location';
  }else if(c['WIZ_Zone'] == 'ADVANCED LOCATION'){
    ret.area = 'Advanced Location';
  }else if(c['WIZ_Zone'] == 'LOGGED'){
    ret.area = 'Logged';
  }else if(c['WIZ_Zone'] == 'CONTINUUM'){
    ret.area = 'Continuum';
  }else if(c['WIZ_Zone'] == 'CONTINUUM: STARTING'){
    ret.area = 'Continuum';
    ret.starting_mission = true;
  }else if(c['WIZ_Zone'] == 'STARTING MISSION'){
    ret.area = 'Missions';
    ret.starting_mission = true;
  }else if(c['WIZ_Zone'] == 'ADVANCED MISSION'){
    ret.area = 'Missions';
  }else if(c['WIZ_Zone'] == 'VOID'){
    ret.area = 'Void';
  }else if(c['WIZ_Zone'].includes('CAPTAIN') && c['WIZ_Zone'].includes('LOG')){
    ret.area = 'Logged';
  }else if(c['WIZ_Zone'].startsWith('OPPONENT ')){
    ret.area = c['WIZ_Zone'].toLowerCase();
  }else if(c['WIZ_Zone'].trim()){
    console.warn('Unknown card zone: '+c['WIZ_Zone'], c);
    ret.area = c['WIZ_Zone'];
  }/*else{
    console.log('unknown zone', c['WIZ_Zone'], c);
  }*/
 /* if(c['@Pip2']) ret.pips++;
  if(c['@Pip3']) ret.pips++;

  if(ret.pips == 1){
    ret.area = 'Starter';
  }else if(ret.pips == 2){
    ret.area = 'Reserve';
  }else if(ret.pips == 3){
    ret.area = 'Development';
  }*/
  
  

  ret.allText = '';
  if(c['RedText']){
    ret.playText = c['RedText'];
    ret.allText += ret.playText + ' ';
  }
  if(c['GoldText']){
    ret.ongoingText = c['GoldText'];
    ret.allText += ret.ongoingText + ' ';
  }
  if(c['IncomeText']){
    ret.incomeText = c['IncomeText'];
    ret.allText += ret.incomeText + ' ';
  }
  
  if(c['GoalText']){
    ret.goal = c['GoalText'];
    ret.allText += ret.goal + ' ';
  }
  if(c['RewardText']){
    ret.reward = c['RewardText'];
    ret.allText += ret.reward + ' ';
  }
  if(c['GreenText']){
    ret.cleanupText = c['GreenText'];
    ret.allText += ret.cleanupText + ' ';
  }
  if(c['DevCostText'] && !c['DevCostText'].toLowerCase().includes('core box')){
    ret.devCost = c['DevCostText'];
    ret.allText += ret.devCost + ' ';
  }

  ret.allTextOriginal = ret.allText;
  
  if(c['VPValue']){
    let vp = parseInt(c['VPValue']);
    if(c['VPValue'].trim().endsWith('*')){
      ret.special_vp = true;
      //console.log('special vp card:', ret)
    }
    if(!isNaN(vp)){
      ret.vp = vp;
    }else if(c['VPValue'].trim() == '?'){
      ret.focus_vp = true; // It's a focus card
    }else if(c['VPValue'].trim() == 'wild'){
      ret.focus_vp = true;
      ret.stripe = 'wild';
    }
  }
  if(c['Ref']) ret.id = c['Ref'];
  ret.reverse = getReverse(ret.id);
  if(isBack(ret.id)) ret.area = 'BACK';
  if(c['@attack']) ret.attack = true;
  if(c['@Stripe']){
    if(match = c['@Stripe'].match(/stripe-([^.]+)\.psd/)){
      ret.stripe = match[1].toLowerCase().trim();
    }
  }
  ret.traits = [];
  for(let i = 0; i < 10; i++){
    if(!c['@Trait'+i]) continue;
    if(match = c['@Trait'+i].match(/trait-([^.]+)\.psd/)){
      ret.traits = [...ret.traits, match[1].toLowerCase()];
    }
  }
  ret.values = [];
  ret.ships =[];
  
  for(let i = 0; i < 5; i++){
    if(!c['@Value'+i]) continue;
    if(match = c['@Value'+i].match(/value-drone:_(\d+)\.psd/)){
      if(!ret.drones) ret.drones = {};
      if(!ret.drones[ret.deck]) ret.drones[ret.deck] = 0;
      ret.drones[ret.deck] += parseInt(match[1])
    }else if(match = c['@Value'+i].match(/drones-(\d+)\*?\.psd/)){
      if(!ret.drones) ret.drones = {};
      if(!ret.drones[ret.deck]) ret.drones[ret.deck] = 0;
      ret.drones[ret.deck] += parseInt(match[1])
    }else if(match = c['@Value'+i].match(/value-([^.]+)\.psd/)){
      ret.values = [...ret.values, match[1].toLowerCase()];
    }else if(match = c['@Value'+i].match(/ships\/(.+)\.psd/)){
      ret.ships = [...ret.ships, match[1].toLowerCase()];
    }else if(match = c['@Value'+i].match(/away-teams-([^.]+)\.psd/)){
      if(!ret.away_teams) ret.away_teams = {};
      if(!ret.away_teams[ret.deck]) ret.away_teams[ret.deck] = 0;
      ret.away_teams[ret.deck] += parseInt(match[1]);
    }
  }

  if(ret.ships && ret.ships.length > 0){
    res.update(r => {
      r.ships = [...r.ships, ...ret.ships];
      return r;
    })
  }

  try{
      let atCard, atOps;
      if(c['TSCard']){
        atCard = JSON.parse(c['TSCard']);
      }
      if(c['TSOps']){
        atOps = JSON.parse(c['TSOps']);
      }
      res.update(r => {
        if(atCard) r.atCards[ret.id] = atCard;
        if(atOps) r.atOps[ret.id] = atOps;
        return r;
      })
  }catch(e){
    console.log('Error parsing JSON card info/ops', e);
  }

  if(ret.name.trim().toLowerCase() == 'liam shaw' && ret.id == '47O903/26') ret.id = '47O904/26';

  if(ret.suits.includes('captain') && !ret.away_teams && !ret.drones){
    ret.away_teams = {};
    //ret.away_teams[ret.deck] = 5; // Just as a default TODO remove later
  }

  ret.box = c['Box'];

  if((ret.suits.includes('ship')|| ret.name.trim().toLowerCase() == 'gomtuu') && ret.ships.length == 0 && !ret.allText.toLowerCase().includes('this ship cannot be warped')){
    ret.ships = [`${ret.name.toLowerCase().replaceAll(` `, `_`)}`]; // For placeholders
  }

  ret.entered = {};
  ret.left = {};
  ret.stats = {
    obj: {}
  };
  ret.chosenOptions = {};

  for(let s of ret.ships){
    // Add to res
    res.update(r => {
      r.ships = Array.from(new Set([...r.ships, s]));
      return r;
    })
  }

  res.update(r => {
    r.cardsByRef[ret.id] = c;
    return r;
  })

  //if(ret.name.includes('Enterprise-F')) console.log('Enterprise', ret);

  return ret;
}

function analyseComponents(cards){
  let bits = [];
  let typedKeys = {};
  let filter = ['verb', 'actor']
  let keysObjects = {};
  for(let card of cards){
    let pct = get(res).parsedCardText[card.id];
    if(!pct) continue;
  
    for(let k of Object.keys(pct)){
      let bit = pct[k];
      if(!Array.isArray(bit)) bit = [ bit ]
      for(let e of bit){
        let eff = e.effect;
        if(!eff) continue;
        if(!Array.isArray(eff)) eff = [ eff ]
        for(let i = 0; i < eff.length; i++){
          let arr = eff[i];
          if(!Array.isArray(arr)) arr = [arr]
          for(let element of arr){
            bits.push(...Object.keys(element));
            for(let k of Object.keys(element)){
              if(!keysObjects.hasOwnProperty(k)) keysObjects[k] = [];
              if(!keysObjects[k].includes(element[k])) keysObjects[k].push(element[k]);
            }
            if(element.verb){
              if(!typedKeys[element.verb]) typedKeys[element.verb] = [];
              typedKeys[element.verb] = Array.from(new Set([...typedKeys[element.verb], ...Object.keys(element).filter(k => !filter.includes(k))]));
            }
           // console.log(`${card.id}, ${k}[${i}]: ${Object.keys(element).join(', ')}`);
          }
          
        }
        
      }
    }
  }
  
  return {
    allKeys: Array.from(new Set(bits)),
    typedKeys,
    keysObjects
  }
}

function findIncompleteText(card){
  let pct = get(res).parsedCardText[card.id];
  if(!pct) return;
  let bits = [];
  let complete = [];
  let a = pct;
  if(!Array.isArray(a)) a = [ a ]
  for(let pct of a){
    for(let k of Object.keys(pct)){
      let effect = pct[k].effect;
      if(!effect){
        bits.push({type: k, text: pct[k].text, fullEffect: null})
        continue;
      }
      for(let e of effect){
        if(e.type == 'incomplete'){
          bits.push({type: k, text: e.text, fullEffect: e})
        }else{
          complete.push({type: k, text: e.text, fullEffect: e})
        }
        if(e.type == 'choice'){
          for (let c of e.choices){
            if(Array.isArray(c)){
              for(let d of c){
                if(d.type == 'incomplete'){
                  bits.push({type: k, text: d.text, fullEffect: e})
                }else{
                  complete.push({type: k, text: d.text, fullEffect: e})
                }
              }
            }else{
              if(c.type == 'incomplete'){
                bits.push({type: k, text: c.text, fullEffect: e})
              }else{
                complete.push({type: k, text: c.text, fullEffect: e})
              }
            }
            
          }
        }
      }
    }
  }
  

  return {
    incomplete: bits,
    complete
  };
}



export async function loadCards(){
    let cards = await loadSheets({
      id: sheetID(),
      sheetName: '_Master',
      startCol: 'A',
      endCol: 'XX'
    });

    let ret = cards.filter(c => c && c['Name'].trim()).map(c => convertNewCard(c)).filter(c => c.id);

    return ret;
    //console.log(cards);
}

/*async function loadStardatesOld(){
  let cards = await loadSheets({
    id: sheetID(),
    sheetName: '_Stardates',
    startCol: 'A',
    endCol: 'I'
  });
  
  let sc = [];
  for(let c of cards){
    if(!c['Ref']) continue;
    let entry = {
      ref: c['Ref'],
      glory: parseInt(c['Glory']),
      eventText: c['Event']
    };
    if(c['Event'].includes('any neutral')){
      entry.event = 'wipe_all';
    }else if(c['Event'].includes('wipe the market')){
      entry.event = 'wipe_market';
    }else if(c['Event'].includes('end game')){
      entry.event = 'end_game';
    }
    //console.log(c);
    if(c['Not In Practice']){
      console.log('not practice')
      entry.notPractice = true;
    }
    sc.push(entry);
  }

  return sc;
}*/



async function loadStardates(){
  let cards = await loadSheets({
    id: sheetID(),
    sheetName: 'Stardates-main',
    startCol: 'A',
    endCol: 'N'
  });
  
  let sc = [];
  for(let c of cards){
    if(!c['Ref']) continue;
    let entry = {
      ref: c['Ref'],
      id: `SD_${c['Ref']}`, // Ref is unique per row: this keys the parsed text in res.parsedCardText
      sequence: c['Sequence'],
      glory: parseInt(c['Glory']),
      eventText: c['Effect'],
      mode: c['Mode'].trim(),
      module: false,
      botActions: parseInt(c['Bot Cards played'])
    };
    if(entry.mode.includes('(')){
      // It has a module, so filter out
      let [basic, mod] = entry.mode.split('(');
      basic = basic.trim();
      mod = mod.replace(')', '').trim();
      entry.module = mod;
      entry.mode = basic;
    }
    // !!TODO replace below with actual parsing soon, for future-proofing
    if(c['Effect'].includes('any neutral')){
      entry.event = 'wipe_all';
    }else if(c['Effect'].toLowerCase().includes('wipe the market')){
      entry.event = 'wipe_market';
    }else if(c['Effect'].toLowerCase().includes('end of the game') && c['Effect'].toLowerCase().includes('from the *badlands*')){
      entry.event = 'end_game_badlands';
    }else if(c['Effect'].toLowerCase().includes('end of the game')){
      entry.event = 'end_game';
    }else{
      entry.event = 'none';
      
    }
    //console.log(c);
    /*if(c['Not In Practice']){
      console.log('not practice')
      entry.notPractice = true;
    }*/
    if(sc.some(e => e.id == entry.id)) console.warn(`Duplicate Stardate Ref ${entry.ref}: both rows will share one set of parsed effects`);
    sc.push(entry);
  }
  console.log('stardate cards', sc);
  return sc;
}

// Stardates aren't cards (no uniqueID, no cardLog, no image), but their text is parsed as if they
// were: the worker only needs {id, allText, botCard}, and the result lands in res.parsedCardText
// where getCardEffect can find it.
function stardatesToParse(){
  return (get(res).allStardates || []).filter(sd => sd.id && sd.eventText).map(sd => {
    return {id: sd.id, allText: sd.eventText, botCard: false, stardate: true};
  });
}


async function loadSets(){
  let sets = [];
  let data = await loadSheets({
    id: sheetID(),
    sheetName: '_Sets',
    startCol: 'A',
    endCol: 'F'
  });

  while(!data || !Array.isArray(data)){
    await waitMillis(100);
    data = await loadSheets({
      id: sheetID(),
      sheetName: '_Sets',
      startCol: 'A',
      endCol: 'F'
    });
  }
  
  for(let s of data){
    if(s['RefNumber'] == '' || typeof s['RefNumber'] == 'undefined') continue;
    sets.push({
      ref: s['RefNumber'],
      name: s['Name'],
      decks: (s['Decks'] || '').split(',').map(s => s.trim()),
      type: s['Box Type'],
      modules: s['Module'] ? s['Module'].split(',').map(s => s.trim()) : [],
      numCards: parseInt(s['Card Count']),
      selected: parseInt(s['RefNumber']) == 1 ? true : false
    });
  }

  //console.warn(sets);
  return sets;
}
